import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./MarkdownView.module.css";

type Props = {
  body: string;
  className?: string;
};

const SAFE_URL = /^(https?:|mailto:|\/|#)/i;

const safeUrl = (url: string): string => (SAFE_URL.test(url) ? url : "");

export const MarkdownView = ({ body, className }: Props): JSX.Element => (
  <div className={`${styles.prose} ${className ?? ""}`}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      urlTransform={safeUrl}
      components={{
        a: ({ href, children, ...rest }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
            {children}
          </a>
        ),
      }}
    >
      {body}
    </ReactMarkdown>
  </div>
);
